// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import React from 'react';
import { FinertyLogo } from '@loa/ui-components';

interface PoweredByFinertyProps {
  /** Size variant for different contexts */
  size?: 'small' | 'medium' | 'large';
  /** Position for absolute positioning (optional) */
  position?: 'bottom-left' | 'bottom-right' | 'bottom-center';
  /** Custom class name */
  className?: string;
}

const sizeToHeight = {
  small: 16,
  medium: 20,
  large: 22,
};

export const PoweredByFinerty: React.FC<PoweredByFinertyProps> = ({
  size = 'small',
  position,
  className = ''
}) => {
  // Size configurations
  const sizeConfig = {
    small: {
      fontSize: '0.75rem',
      padding: '6px 12px',
      gap: '6px'
    },
    medium: {
      fontSize: '0.875rem',
      padding: '8px 16px',
      gap: '8px'
    },
    large: {
      fontSize: '1rem',
      padding: '10px 20px',
      gap: '10px'
    }
  };

  const config = sizeConfig[size];

  // Position styles
  const positionStyles: React.CSSProperties = position ? {
    position: 'absolute',
    ...(position === 'bottom-left' && { bottom: '20px', left: '20px' }),
    ...(position === 'bottom-right' && { bottom: '20px', right: '20px' }),
    ...(position === 'bottom-center' && { bottom: '20px', left: '50%', transform: 'translateX(-50%)' })
  } : {};

  return (
    <div
      className={`powered-by-finerty ${className}`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: config.gap,
        padding: config.padding,
        fontSize: '12px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: 'normal',
        color: '#313957',
        ...positionStyles
      }}
    >
      <span className='text-body-04 font-normal leading-normal text-secondary-text font-sans'>Powered by</span>
      <FinertyLogo height={sizeToHeight[size]} />
    </div>
  );
};

export default PoweredByFinerty;
